import { render, staticRenderFns } from "./FishingChallenge.vue?vue&type=template&id=1b8f9c0b&scoped=true&"
import script from "./FishingChallenge.vue?vue&type=script&lang=js&"
export * from "./FishingChallenge.vue?vue&type=script&lang=js&"
import style0 from "./FishingChallenge.vue?vue&type=style&index=0&id=1b8f9c0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f9c0b",
  null
  
)

export default component.exports